export default {
  message: {
    hello: '你好，世界！',
    welcome: '歡迎來到Vue多語言網站',
    products: '產品列表',
    language: '語言',
    chinese_simplified: '簡體中文',
    english: '英文',
    vietnamese: '越南語',
    chinese_traditional: '繁體中文',
    home: '首頁',
    about: '關於我們',
    contact: '聯繫我們',
    sitemap: '網站地圖',
    description: '這是一個支持多語言的Vue網站示例',
    sitemapSubtitle: '本站所有頁面的完整索引，方便搜索引擎抓取和用戶瀏覽',
    staticPages: '靜態頁面',
    productCategories: '產品分類',
    productList: '產品列表',
    allCategories: '所有分類',
    searchProducts: '搜索產品...',
    loadMore: '加載更多',
    xmlSitemap: 'XML網站地圖',
    xmlSitemapDescription: '專用於搜索引擎的標準網站地圖文件（sitemap.xml）',
    priority: '優先級',
    updateFrequency: '更新頻率',
    productUnit: '個產品',
    loading: '加載中...',
    retry: '重試',
    fetchSitemapError: '獲取網站地圖失敗，請稍後重試',
    daily: '每天',
    weekly: '每周',
    monthly: '每月'
  },
  pagination: {
    previous: '上一頁',
    next: '下一頁',
    page_info: '第 {current} / {total} 頁 (共 {count} 條記錄)'
  },
  product: {
    categories: {
      title: '產品類別',
      consumer_mosfet: '消費類MOSFET',
      industrial_mosfet: '工業類MOSFET',
      automotive_mosfet: '汽車類MOSFET',
      power_module: '電源模塊',
      ovp: 'OVP',
      ldo: 'LDO',
      pmic: 'PMIC'
    },
    search: '搜索產品...',
    no_results: '未找到匹配的產品',
    table: {
      model: '型號',
      package: '封裝',
      product_status: '產品狀態',
      mosfet_type: 'MOSFET類型',
      technology: '工藝',
      current: '電流',
      voltage: '電壓',
      datasheet: '數據手冊',
      view_pdf: '查看PDF',
      actions: '操作'
    },
    purchase_button: '購買',
    detail: {
      back: '返回',
      basic_info: '基本資訊',
      technical_params: '技術參數',
      documents: '文件下載',
      download_pdf: '下載數據手冊',
      loading: '加載中...',
      not_found: '產品不存在',
      load_error: '產品詳情加載失敗，請稍後重試。',
      fields: {
        Title: '產品名稱',
        Package: '封裝',
        ProductStatus: '產品狀態',
        MOSFETType: 'MOSFET類型',
        Technology: '工藝技術',
        IDA: '漏極電流(A)',
        VDSMin: '漏源電壓(V)',
        RDSon: '導通電阻(mΩ)',
        VGS: '閘源電壓(V)',
        Qg: '總閘極電荷(nC)',
        Ciss: '輸入電容(pF)',
        Coss: '輸出電容(pF)',
        Crss: '反向傳輸電容(pF)',
        FileUrl: '數據手冊'
      }
    }
  },
  about: {
    company_intro: '公司簡介',
    company_desc: '765.info 專注於為客戶提供高性能、高可靠性的功率半導體解決方案。我們擁有先進的晶片設計技術和成熟的製造工藝，為工業自動化、新能源、智能家居、消費電子等領域提供優質的 MOSFET、DC-DC電源管理IC、AC-DC轉換晶片等核心元器件，助力客戶提升產品能效並降低系統成本。',
    
    core_advantages: '核心優勢',
    advantage_direct_supply_title: '原廠直供',
    advantage_direct_supply_desc: '與原廠深度合作，確保正品貨源，價格優勢明顯。',
    advantage_tech_leadership_title: '技術領先',
    advantage_tech_leadership_desc: '提供 VD-Trench、SJ-MOS、SGT-MOS 等先進工藝的功率器件，滿足高效率、低損耗需求。',
    advantage_solution_support_title: '方案支持',
    advantage_solution_support_desc: '可提供 電機驅動、電源管理、LED照明 等參考設計，縮短客戶研發週期。',
    advantage_quick_response_title: '快速響應',
    advantage_quick_response_desc: '現貨庫存+靈活供應鏈，支持小批量試樣與大規模採購。',
    
    main_products: '主營產品',
    mosfet_series_title: 'MOSFET系列',
    mosfet_low_voltage: '中低壓MOS（20V-200V）：適用於電動工具、鋰電池保護。',
    mosfet_high_voltage: '高壓MOS（500V-650V）：用於工業電源、光伏逆變器。',
    dcdc_chips_title: 'DC-DC降壓晶片',
    dcdc_chips_desc: '系列（40V/2A）、系列（5V/3A），替代進口品牌。',
    acdc_chips_title: 'AC-DC轉換晶片',
    acdc_chips_desc: '等方案，支持家電、智能電表等220V轉5V/12V應用。',
    custom_services_title: '定制服務',
    custom_services_desc: '提供晶片選型、電路優化、模組化設計等技術支持。',
    
    service_areas: '服務領域',
    area_industrial_control: '工業控制（電機驅動、PLC）',
    area_new_energy: '新能源（儲能、電動車充電樁）',
    area_consumer_electronics: '消費電子（快充、LED照明）',
    area_smart_home: '智能家居（家電、安防設備）',
    
    mission_vision: '使命願景',
    mission_vision_desc: '我們以"讓高效功率器件觸手可及"為目標，結合專業技術實力與本地化服務，為客戶提供穩定、創新的半導體解決方案。'
  },
  contact: {
    info_title: '聯繫方式',
    address_title: '地址',
    address_value: '深圳市寶安區福永街道鳳凰社區廣深路福永段109號錦灏大廈2305',
    phone_title: '電話',
    phone_value: '+86 139-8626-3349',
    email_title: '電子郵件',
    hours_title: '工作時間',
    hours_value: '週一至週五，9:00 - 18:00',
    form_title: '聯繫表單',
    name: '姓名',
    name_placeholder: '請輸入您的姓名',
    email: '電子郵件',
    email_placeholder: '請輸入您的電子郵件',
    subject: '主題',
    subject_placeholder: '請輸入主題',
    message: '留言',
    message_placeholder: '請輸入您的留言',
    submit: '提交',
    form_success: '您的留言已成功發送。我們將盡快與您聯繫！',
    location: '我們的位置',
    map_placeholder: '正在加載地圖...',
    email_note: '提交後，我們的團隊將收到您的訊息',
    errorMessage: '郵件發送失敗，請稍後再試。'
  }
}